// items - array of models
// filters - module filters manager
// filters.manager - instance of GenericListFiltersManager
// filters.preFilters - is object of simple filters that are not in FiltersManager (filters panel) - {fieldId: [...values]}

export default function filtersOperator(items:any[], filters:any) {

    // if preFilters defined then filter out items that are not relevant
    if (!_.isEmpty(filters.preFilters)) {
        // all preFilter fields
        const preFiltersFieldIds = _.keys(filters.preFilters)
        // check if any of filter values match item value
        const checkFilterValues = (fieldId:string, item:any) => filters.preFilters[fieldId].includes(item[fieldId])
        // check all preFilters for item and stop on first match (_.some)
        const checkFilterFieldsForItem = (item:any) => _.some(preFiltersFieldIds, fieldId=>checkFilterValues(fieldId, item))
        // filter items according preFilters
        items = _.filter(items, item=>checkFilterFieldsForItem(item))
    }

    // filter using filters manager (by fields selected in filters panel)
    return filters.manager.filterItems(items)
}